import axios from 'axios'
import { queryBuilder, urlMapper, getHeaderWithoutToken } from '../helpers/utility'

const get = ({ url = '', query = {}, params = {} }) => {
  const queryString = queryBuilder(query)
  const mappedUrl = urlMapper(url, params)
  const combinedUrl = `${mappedUrl}${queryString}`
  return axios
    .get(combinedUrl, { headers: getHeaderWithoutToken() })
    .catch(error => {
      if (error.response) {
        throw error.response
      } else {
        throw error
      }
    })
    .then(response => {
      return response
    })
}

export default get
